export var RootDashboardFolder;
(function (RootDashboardFolder) {
    RootDashboardFolder["NAME"] = "ROOT_FOLDER";
    RootDashboardFolder["DISPLAY_NAME"] = "Root Folder";
})(RootDashboardFolder || (RootDashboardFolder = {}));
export var OOTBDashboardsFolder;
(function (OOTBDashboardsFolder) {
    OOTBDashboardsFolder["NAME"] = "logzio-dashboards";
    OOTBDashboardsFolder["DISPLAY_NAME"] = "Integrations Dashboards";
    OOTBDashboardsFolder["PROJECT_ID"] = "logzio-dashboards";
})(OOTBDashboardsFolder || (OOTBDashboardsFolder = {}));
export var K8s360DashboardsFolder;
(function (K8s360DashboardsFolder) {
    K8s360DashboardsFolder["PROJECT_ID"] = "k8s-360";
})(K8s360DashboardsFolder || (K8s360DashboardsFolder = {}));
export var LogzioAdmin;
(function (LogzioAdmin) {
    LogzioAdmin[LogzioAdmin["ID"] = 0] = "ID";
    LogzioAdmin["DISPLAY_NAME"] = "Logz.io";
})(LogzioAdmin || (LogzioAdmin = {}));
export var DashboardsHubPageSubjects;
(function (DashboardsHubPageSubjects) {
    DashboardsHubPageSubjects["Page"] = "dashboards-hub-page";
    DashboardsHubPageSubjects["Table"] = "dashboards-hub-table";
    DashboardsHubPageSubjects["TableEmptyState"] = "dashboards-hub-table-empty-state";
    DashboardsHubPageSubjects["CreateNewDashboardButton"] = "dashboards-hub-create-new-dashboard-button";
    DashboardsHubPageSubjects["CreateNewDashboardModal"] = "dashboards-hub-create-new-dashboard-modal";
    DashboardsHubPageSubjects["DeleteDashboardButton"] = "dashboards-hub-delete-dashboard-button";
    DashboardsHubPageSubjects["SuccessfullyCreatedFolder"] = "dashboards-hub-successfully-created-folder";
    DashboardsHubPageSubjects["SuccessfullyDeletedNotification"] = "dashboards-hub-successfully-deleted-notification";
    DashboardsHubPageSubjects["ManageTagsButton"] = "dashboards-hub-manage-tags-button";
})(DashboardsHubPageSubjects || (DashboardsHubPageSubjects = {}));
export var ViewUnifiedDashboardPageSubjects;
(function (ViewUnifiedDashboardPageSubjects) {
    ViewUnifiedDashboardPageSubjects["Page"] = "view-unified-dashboard-page";
    ViewUnifiedDashboardPageSubjects["DrilldownPanel"] = "view-unified-dashboard-drilldown-panel";
    ViewUnifiedDashboardPageSubjects["CloseDrilldownPanelButton"] = "view-unified-dashboard-close-drilldown-panel-button";
    ViewUnifiedDashboardPageSubjects["DrilldownZoomOutButton"] = "view-unified-dashboard-drilldown-zoom-out-button";
    ViewUnifiedDashboardPageSubjects["SuccessfullySavedDashboard"] = "view-unified-dashboard-successfully-saved-dashboard";
})(ViewUnifiedDashboardPageSubjects || (ViewUnifiedDashboardPageSubjects = {}));
//# sourceMappingURL=dashboards-hub.js.map